import React, { lazy } from 'react';
import { ProtectedRoute } from '@components';

const WxPayrollCard = lazy(() => import('./record'));

export default {
  path: 'wxPayrollCard',
  element: <ProtectedRoute title="绑定微工卡" component={<WxPayrollCard />} />,
};
